import React, { useState, useEffect } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import Header from '../../Header';
import LeadDetailsTable from './LeadDetailsTable';

const MainLeadPage = () => {
  const location = useLocation();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [userId, setUserId] = useState<string>("");
  const [type, setType] = useState<string>("total");
  const [city, setCity] = useState<string>("");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    // Get userId from URL params or query params
    const userIdFromParams = params.userId || "";
    const userIdFromQuery = searchParams.get('userId') || "";
    
    // Priority: params > query params
    const finalUserId = userIdFromParams || userIdFromQuery;
    
    // Get type from query params
    const typeFromQuery = searchParams.get('type') || "total";
    
    // Get city from query params
    const cityFromQuery = searchParams.get('city') || "";

    console.log("MainLeadPage - Location:", location.pathname);
    console.log("MainLeadPage - Params:", params);
    console.log("MainLeadPage - Search Params:", searchParams.toString());
    console.log("MainLeadPage - userId from params:", userIdFromParams);
    console.log("MainLeadPage - userId from query:", userIdFromQuery);
    console.log("MainLeadPage - Final userId:", finalUserId);
    console.log("MainLeadPage - type:", typeFromQuery);
    console.log("MainLeadPage - city:", cityFromQuery);

    setUserId(finalUserId);
    setType(typeFromQuery);
    setCity(cityFromQuery);
  }, [location, params, searchParams]);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="main-lead-page">
      <div className={`main-lead-content ${sidebarCollapsed ? 'expanded' : ''}`}>
        <Header />

        <div className="lead-page-content">
          {userId ? (
            <LeadDetailsTable 
              userId={userId}
              type={type}
              city={city}
            />
          ) : (
            <div className="no-data-message">
              <h3>No User Selected</h3>
              <p>Please select a partner and city to view leads</p>
              <button 
                className="go-back-btn"
                onClick={() => window.location.href = '/admin'}
              >
                ← Go to City-Wise Leads
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MainLeadPage;